/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Spin,
  Tabs,
  Modal,
  DatePicker,
} from 'antd';
import {
  CheckCircleOutlined,
} from '@ant-design/icons';
import Select from 'components/Select';
import { onError, onSuccess } from 'utils/handlers';
import {
  getEstadosGlobales,
  getPeriodicidadesDePagos,
} from 'api/catalogos';
import Table from 'components/Table';
import { ESTATUS_ACTIVO, ESTATUS_AUTORIZADO, ESTATUS_INACTIVO } from 'utils/constants';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDelete from 'components/ModalDelete';
import FormSubmitControls from 'components/FormSubmitControls';
import {
  autorizarIncidenciaPeriodicidad,
  deleteIncidenciaPeriodicidad,
  getIncidenciaPeriodicidad, getIncidenciasPeriodicidades, getIncidenciasPeriodicidadesPag, patchIncidenciaPeriodicidad, postIncidenciaPeriodicidad,
} from 'api/configuraciones/clock/Incidencias/IncidenciaPeriodicidad';
import { formatReceived, formatReceivedValues } from 'utils/formatValues';
import moment from 'moment/moment';
import { getConfiguracionIncidencias } from 'api/nominas/incidencias/configuracionIncidencias';
import { getTiposDeIncidenciasUnidades } from 'api/nominas/incidencias/tiposIncidenciasUnidades';
import { getAplicaciones } from 'api/catalogos/PeriocidadDeAplicacion';

export const periodicidadConfigPermission = {
  permissionModel: 'incidenciaPeriocidad',
  catalogsModels: [],
  tabsModels: [],
};

const PeriodicidadConfigReloj = ({ permission }) => {
  const [form] = Form.useForm();
  const [isAdding, setAdding] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [periocidadAplicacion, setPeriocidadAplicacion] = useState([]);
  const [estados, setEstados] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [disableFields, setDisableFields] = useState(false);
  const [pageActual, setPageActual] = useState(1);
  const [periocidadPago, setPeriocidadPago] = useState([]);

  const formInstances = [
    form,
  ];

  const fetchPaginated = async (page = 1, q = null) => {
    try {
      setLoading(true);

      const cleanPage = Number(String(page).replace(/\D/g, ''));
      const _data = await getIncidenciasPeriodicidadesPag({ page: cleanPage, ...q });

      const { results } = _data;

      setSelectedRowKeys([]);
      setPageActual(cleanPage);
      setData({ ..._data, results: [...results] });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    const _data = await getIncidenciasPeriodicidades();
    setData(formatReceived(_data));
    setLoading(false);
  };
  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _periocidadPago,
        _periocidadAplicacion,
        _data,
        _estados,
      ] = await Promise.all([
        getPeriodicidadesDePagos({ estados_globales: ESTATUS_AUTORIZADO }),
        getAplicaciones({ estados_globales: ESTATUS_AUTORIZADO }),
        getIncidenciasPeriodicidades(),
        getEstadosGlobales(),
      ]);
      if (mounted) {
        setPeriocidadPago(_periocidadPago);
        setPeriocidadAplicacion(_periocidadAplicacion);
        setData(_data);
        setEstados(_estados);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    setSelectedData({});
  };
  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    setAdding(false);
    const [key] = selectedRowKeys;
    const match = responseData || data?.results?.find((item) => item.id === key);
    const _periodicidadConfigReloj = await getIncidenciaPeriodicidad(match.id);

    setTimeout(() => {
      if (_periodicidadConfigReloj) {
        const formValues = {
          periodo_de_evaluacion: _periodicidadConfigReloj.periodo_de_evaluacion?.id,
          periodo_de_descuento: _periodicidadConfigReloj.periodo_de_descuento?.id,
          aplicacion_de_descuento: _periodicidadConfigReloj.aplicacion_de_descuento?.id,
          // Asigna el ID del estado global
          // Convierte la fecha de vigencia final a objeto moment si existe, si no null
          vigencia_final: _periodicidadConfigReloj.vigencia_final
            ? moment(_periodicidadConfigReloj.vigencia_final)
            : null,

          // Asigna el ID del estado global
          estados_globales: _periodicidadConfigReloj.estados_globales?.id, //  aquí sí es un ID
        };
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(formValues));
          setDisableFields(_periodicidadConfigReloj?.estados_globales?.id !== ESTATUS_ACTIVO);
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };
  const onClickAdd = () => {
    setAdding(true);
    form.resetFields();
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const onFinish = async (_continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();

      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;

      if (values.vigencia_final?.format) {
        values.vigencia_final = values.vigencia_final.format('YYYY-MM-DD');
      }
      const saved = await (key ? patchIncidenciaPeriodicidad(key, values) : postIncidenciaPeriodicidad(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteIncidenciaPeriodicidad(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });

    const dataForForm = {
      ...record,
      vigencia_final: record.vigencia_final
        ? moment(record.vigencia_final)
        : null,
    };

    form.setFieldsValue(dataForForm);
  };
  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };
  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar un Incidencia Periodicidad ya autorizado');
        return;
      }
      const saved = await autorizarIncidenciaPeriodicidad(key);
      if (saved) {
        const _data = await getIncidenciasPeriodicidades();
        setData(formatReceived(_data));
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Periodo de Evaluacion',
      dataIndex: 'periodo_de_evaluacion',
      key: 'periodo_de_evaluacion',
      width: 200,
      render: (_, record) => record?.periodo_de_evaluacion?.descripcion || 'n/a',
    },
    {
      titleText: 'Periodo de Descuento',
      dataIndex: 'periodo_de_descuento',
      key: 'periodo_de_descuento',
      width: 200,
      render: (_, record) => record?.periodo_de_descuento?.descripcion || 'n/a',
    },
    {
      titleText: 'Aplicación de Descuento',
      dataIndex: 'aplicacion_de_descuento',
      key: 'aplicacion_de_descuento',
      width: 200,
      render: (_, record) => record?.aplicacion_de_descuento?.nombre || 'n/a',
    },
    {
      titleText: 'Vigencia Final',
      dataIndex: 'vigencia_final',
      key: 'vigencia_final',
      width: 150,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 180,
      render: (_, record) => record?.estados_globales?.descripcion || 'n/a',
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };

  return (
    <Row align="center" justify="center" className="container">
      <Col span={24}>
        <Spin tip="Cargando..." spinning={loading}>
          <Table
            cols={columns}
            data={data?.results || []}
            pagination={false}
            paginationCallback={fetchPaginated}
            count={data?.count || 0}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            customActions={[
              {
                onClick: () => setVisibleAutorizar(true),
                permission: { model: 'incidenciaperiocidad', action: 'autorizar' },
                icon: <CheckCircleOutlined />,
                text: 'Autorizar',
                disabledBySelection: true,
                disabled: selectedData?.estados_globales?.id !== ESTATUS_ACTIVO,
                className: 'success',
              },
            ]}
            disableDelete={selectedData?.estados_globales?.id !== ESTATUS_ACTIVO}
            permission={permission}
            allowExportParam={false}
            allowSearch={false}
          />
          <Modal
            open={open}
            closable={false}
            maskClosable={!loading}
            keyboard={!loading}
            footer={null}
            title={(
              <FormSubmitControls
                label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Incidencia Periodicidad`}
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
              />
            )}
            onCancel={onCancel}
            forceRender
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstErrorDatePicker
              name="Periodicidad"
              initialValues={{
                estados_globales: ESTATUS_ACTIVO,
              }}
            >
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="periodo_de_evaluacion"
                  label="Periodo de Evaluacion"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={periocidadPago}
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="periodo_de_descuento"
                  label="Periodo de Descuento"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={periocidadPago}
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="aplicacion_de_descuento"
                  label="Aplicación de Descuento"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select
                    labelProp="nombre"
                    keyProp="id"
                    dataSource={periocidadAplicacion}
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="vigencia_final"
                  label="Vigencia Final"
                  hasFeedback
                >
                  <DatePicker
                    allowClear
                    format="YYYY-MM-DD"
                    disabled={isAdding || selectedData?.estados_globales?.id === ESTATUS_INACTIVO}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="estados_globales"
                  label="Estatus"
                  hasFeedback
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={estados}
                    activeInactive={selectedData?.estados_globales?.id === ESTATUS_ACTIVO}
                    disabled={selectedRowKeys.length <= 0 || disableFields}
                    onChange={(val) => setVisibleConfirmInactivo(val === ESTATUS_INACTIVO)}
                  />
                </Form.Item>
              </Col>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Modal>
          <ModalDelete
            onDelete={deleteItem}
            onCancel={() => setVisibleAlert(false)}
            open={visibleAlert}
            content={`Incidencia Periodicidad ${form.getFieldValue('concepto_de_evaluacion')?.nombre || ''}`}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={onConfirmAutorizar}
            ConfirmAutorize
            onCancel={() => setVisibleAutorizar(false)}
            contentTitle={`Autorizar Incidencia Periodicidad ${form.getFieldValue('concepto_de_evaluacion')?.nombre || ''}`}
            open={visibleAutorizar}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={() => setVisibleConfirmInactivo(false)}
            ConfirmInactive
            onCancel={() => {
              form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
              setVisibleConfirmInactivo(false);
            }}
            open={visibleConfirmInactivo}
            contentTitle={`Inactivar Incidencia Periodicidad ${form.getFieldValue('concepto_de_evaluacion')?.nombre || ''}`}
            loading={loading}
          />
        </Spin>
      </Col>
    </Row>
  );
};

export default PeriodicidadConfigReloj;
